import { Title, Flex, Group, Button, Tabs, ScrollArea, Loader, Divider } from '@mantine/core';
import { modals } from '@mantine/modals';

import {
  PaymentSystem,
  MexcPaymentSystem,
  CreatePaymentSystemForm,
  useCreatePaymentSystems,
  useGetPaymentSystems,
} from '@/modules/payment-systems';

import {
  RemotePaymentMethods,
} from '@/modules/remote-payment-methods';

export const PaymentSystems = () => {
  const {
    data: paymentSystems,
    isLoading,
  } = useGetPaymentSystems();

  const {
    handleCreatePaymentSystem,
  } = useCreatePaymentSystems();

  const openCreateModal = () => modals.open({
    title: 'Добавление платёжной системы',
    centered: true,
    children: (
      <CreatePaymentSystemForm
        onSubmit={handleCreatePaymentSystem}
        onClose={modals.closeAll}
      />
    ),
  });

  const openMexcModal = () => modals.open({
    title: 'Добавление MEXC',
    centered: true,
    size: 'lg',
    children: <MexcPaymentSystem onClose={modals.closeAll} />,
  });

  if (isLoading || !paymentSystems) {
    return (
      <Group justify="center">
        <Loader color="blue" />
      </Group>
    );
  }

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Платёжные системы</Title>

        <Group>
          {!paymentSystems.some((item) => item.name === 'mexc') && (
            <Button variant="outline" onClick={openMexcModal}>
              Добавить MEXC
            </Button>
          )}
          <Button variant="filled" onClick={openCreateModal}>
            Создать
          </Button>
        </Group>
      </Flex>

      <Tabs defaultValue={paymentSystems[0]?.name} keepMounted={false}>
        <ScrollArea scrollbarSize={2} scrollbars="x">
          <Tabs.List mb={20} style={{ flexWrap: 'nowrap' }} bga="scroll">
            {paymentSystems.map((item) => (
              <Tabs.Tab key={item.id} value={item.name}>
                {item.name}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </ScrollArea>

        {paymentSystems.map((item) => (
          <Tabs.Panel key={item.id} value={item.name}>
            {item.name === 'mexc' ? (
              <MexcPaymentSystem item={item} />
            ) : (
              <>
                <PaymentSystem item={item} />

                <Divider my="md" mb={20} />

                <RemotePaymentMethods paymentSystemId={item.id} />
              </>
            )}
          </Tabs.Panel>
        ))}
      </Tabs>
    </>
  );
};
